var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Metering_Dashboard",
    "data-name": "Metering Dashboard",
    transform: "translate(-60 -2156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(60 2156)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50722",
    "data-name": "Group 50722",
    transform: "translate(-19 -153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bar-chart",
    transform: "translate(94.787 2325.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17448",
    "data-name": "Group 17448",
    transform: "translate(1.213 15.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17447",
    "data-name": "Group 17447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M3.877,234.667H.546c-.184,0-.333.282-.333.629v15.1c0,.347.149.629.333.629H3.877c.184,0,.333-.282.333-.629V235.3C4.21,234.949,4.061,234.667,3.877,234.667Z",
    transform: "translate(-0.213 -234.667)",
    fill: "#fb8b23"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17450",
    "data-name": "Group 17450",
    transform: "translate(13.978 6.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17449",
    "data-name": "Group 17449",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M195.45,0h-3.331c-.184,0-.333.236-.333.527V24.775c0,.291.149.527.333.527h3.331c.184,0,.333-.236.333-.527V.527C195.783.236,195.634,0,195.45,0Z",
    transform: "translate(-191.786)",
    fill: "#fb8b23"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17452",
    "data-name": "Group 17452",
    transform: "translate(26.768 -0.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17451",
    "data-name": "Group 17451",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M387.45,106.667h-3.331c-.184,0-.333.383-.333.855v30.77c0,.472.149.855.333.855h3.331c.184,0,.333-.383.333-.855v-30.77C387.783,107.05,387.634,106.667,387.45,106.667Z",
    transform: "translate(-383.786 -106.667)",
    fill: "#fb8b23"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(91 2321)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.ccf0da39e3324c92a761ca40f534d09f.svg";
export { ForwardRef as ReactComponent };